export const API_EXTERNAL_ENDPOINT = 'escapadas/:slug'

export const API_INTERNAL_ENDPOINT = 'strapi/escapadas/detail'
